<template>
  <div class="error-page">
    <img
      class="background-circles_right"
      src="@Shared/assets/images/circles-right-form.svg"
      alt="Background shapes"
    />
    <img
      class="background-circle_left"
      src="@Shared/assets/images/small-green-semi-circle.svg"
      alt="Background shapes"
    />
    <div class="vcore_container pe_container">
      <div class="vcore_row">
        <div class="vcore_col--xs--12">
          <div class="content">
            <div class="red-bar"></div>
            <h2 class="form-title">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                preserveAspectRatio="xMidYMid"
                width="48"
                height="48"
                viewBox="0 0 48 48"
              >
                <path
                  d="M24.000,47.999 C10.767,47.999 -0.000,37.233 -0.000,24.000 C-0.000,10.766 10.767,-0.000 24.000,-0.000 C37.233,-0.000 48.000,10.766 48.000,24.000 C48.000,37.233 37.233,47.999 24.000,47.999 ZM24.000,2.000 C11.869,2.000 2.000,11.868 2.000,24.000 C2.000,36.131 11.869,45.999 24.000,45.999 C36.131,45.999 46.000,36.131 46.000,24.000 C46.000,11.868 36.131,2.000 24.000,2.000 ZM24.000,38.999 C22.897,38.999 22.000,38.102 22.000,37.000 C22.000,35.897 22.897,34.999 24.000,34.999 C25.102,34.999 26.000,35.897 26.000,37.000 C26.000,38.102 25.102,38.999 24.000,38.999 ZM24.000,31.999 C23.447,31.999 23.000,31.552 23.000,31.000 L23.000,13.000 C23.000,12.448 23.447,12.000 24.000,12.000 C24.553,12.000 25.000,12.448 25.000,13.000 L25.000,31.000 C25.000,31.552 24.553,31.999 24.000,31.999 Z"
                />
              </svg>
              Something went wrong.
            </h2>
            <div class="form-description">
              We’re sorry. If you need help, please contact your provider.
            </div>
          </div>
        </div>
      </div>
      <div class="vcore_row buttons">
        <div class="vcore_col--xs--12 vcore_col--md--3 vcore_col--lg--2">
          <Button
            id="error-page_error-btn"
            color="blue"
            :block="true"
            size="large"
            @click.native="handleErrorBtnClick"
            >Go to Home</Button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Button from "@Shared/components/Button";

export default {
  name: "ErrorPage",
  components: {
    Button,
  },
  methods: {
    handleErrorBtnClick() {
      this.$router.replace({ name: "enroll" });
    },
  },
};
</script>

<style lang="scss" scoped>
.error-page {
  padding-top: 70px;
  padding-bottom: 200px;
}

.content {
  border: 1px solid #d3d6de;
  border-top: 0;
  margin-top: -7.5px;
  padding: 60px 35px;
  background-color: #ffffff;
  box-shadow: 0 2px 14px 0 rgba(119, 151, 178, 0.23);
  z-index: -1;
  overflow: hidden;
  position: relative;
}

.red-bar {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 10px;
  background-color: $color_red;
  box-shadow: 0 2px 2px 0 rgba(119, 151, 178, 0.23);
}

.form-title {
  svg {
    fill: $color_red;
    fill-rule: evenodd;
    height: 30px;
    width: 30px;
    vertical-align: middle;
    margin-bottom: 5px;
  }
}

.form-description {
  margin-top: 30px;

  p + p {
    margin-top: 20px;
  }
}

.buttons {
  margin-top: 20px;
}

.background-circles_right {
  position: absolute;
  top: 193px;
  right: 0;
}

.background-circle_left {
  position: absolute;
  top: 153px;
  left: 0;
  height: 125px;
}
</style>
